import { FormattedMetricDistributionBucket } from './metrics';

type DistributionBucket = FormattedMetricDistributionBucket['buckets'][number];

// zeroing rather than removing the end buckets approximates the 5th to 95th percentile while the chart keeps
// spanning the pool's full min to max
export const hideDistributionTails = (buckets: DistributionBucket[]): DistributionBucket[] => {
  if (!buckets.length) return buckets;
  const bucketIndices = buckets.map(({ bucketIndex }) => bucketIndex);
  const first = Math.min(...bucketIndices);
  const last = Math.max(...bucketIndices);

  return buckets.map(bucket =>
    bucket.bucketIndex === first || bucket.bucketIndex === last ? { ...bucket, frequency: 0 } : bucket,
  );
};
